var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCloseBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7678_28215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83317 15.8332L4.6665 14.6665L9.33317 9.99984L4.6665 5.33317L5.83317 4.1665L10.4998 8.83317L15.1665 4.1665L16.3332 5.33317L11.6665 9.99984L16.3332 14.6665L15.1665 15.8332L10.4998 11.1665L5.83317 15.8332Z",
    fill: "#4E629F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7678_28215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseBlue);
export default __webpack_public_path__ + "static/media/icon_close_blue.feba72badcfe24cc68a21cccc0c77894.svg";
export { ForwardRef as ReactComponent };